import { ChakraProps } from '@aloft/toolkit-sui/chakra';

import { UNSET_COLUMN_SIZE } from './constants';

export function getCellWidthStyles(size: number): ChakraProps {
  if (size === UNSET_COLUMN_SIZE) return {};
  return {
    boxSizing: 'content-box', // Gross, but means we don't have to hardcode padding values when setting `maxWidth` and `minWidth`
    width: `${size}px`,
    maxWidth: `${size}px`,
    minWidth: `${size}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
}
